import React from 'react'

export default function Notepad() {
  return (
    <div>Notepad</div>
  )
}
